import { Link } from "react-router-dom";
import Socials from "../Socials";
import { NAV, BRAND, EMAIL } from "../../data/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="/" className="footer__logo" aria-label={`${BRAND} home`}>
              <span className="brand-wordmark brand-wordmark--lg">{BRAND}</span>
            </Link>
            <p className="footer__tagline">
              Auto-staking & auto-compounding on TON. Hold DREAM, earn rewards
              rebased every 30 minutes.
            </p>
            <a href={`mailto:${EMAIL}`} className="footer__email">
              {EMAIL}
            </a>
          </div>

          <nav className="footer__nav" aria-label="Footer">
            <h2 className="footer__heading">Explore</h2>
            <ul className="flex flex-col gap-2">
              {NAV.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="footer__link">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="footer__channels">
            <h2 className="footer__heading">Channels</h2>
            <Socials variant="row" />
          </div>
        </div>

        <div className="footer__bottom">
          <p>
            &copy; {year} {BRAND}. All rights reserved.
          </p>
          <p className="footer__disclaimer">
            Not financial advice. DREAM is a demo project.
          </p>
        </div>
      </div>
    </footer>
  );
}
